import CopilotPromptsAPI from 'dashboard/api/captain/copilotPrompts';

const state = {
    records: [],
    uiFlags: {
        isFetching: false,
        isCreating: false,
        isUpdating: false,
        isDeleting: false,
    },
};

const getters = {
    getRecords: $state => $state.records,
    getUIFlags: $state => $state.uiFlags,
    getActiveByContext: $state => context =>
        $state.records.filter(
            p => p.context_type === context && !p.deleted_at
        ),
    getDeletedByContext: $state => context =>
        $state.records.filter(
            p => p.context_type === context && p.deleted_at
        ),
};

const mutations = {
    SET_RECORDS($state, records) {
        $state.records = records;
    },
    ADD_RECORD($state, record) {
        $state.records.push(record);
    },
    UPDATE_RECORD($state, updatedRecord) {
        const index = $state.records.findIndex(r => r.id === updatedRecord.id);
        if (index !== -1) {
            $state.records.splice(index, 1, updatedRecord);
        }
    },
    SET_UI_FLAG($state, flag) {
        $state.uiFlags = { ...$state.uiFlags, ...flag };
    },
};

const actions = {
    async fetch({ commit }, { assistantId }) {
        commit('SET_UI_FLAG', { isFetching: true });
        try {
            const { data } = await CopilotPromptsAPI.index(assistantId);
            commit('SET_RECORDS', data);
        } catch (error) {
            throw error;
        } finally {
            commit('SET_UI_FLAG', { isFetching: false });
        }
    },

    async create({ commit }, { assistantId, promptData }) {
        commit('SET_UI_FLAG', { isCreating: true });
        try {
            const { data } = await CopilotPromptsAPI.create(
                assistantId,
                promptData
            );
            commit('ADD_RECORD', data);
            return data;
        } catch (error) {
            throw error;
        } finally {
            commit('SET_UI_FLAG', { isCreating: false });
        }
    },

    async update({ commit }, { assistantId, promptId, promptData }) {
        commit('SET_UI_FLAG', { isUpdating: true });
        try {
            const { data } = await CopilotPromptsAPI.update(
                assistantId,
                promptId,
                promptData
            );
            commit('UPDATE_RECORD', data);
            return data;
        } catch (error) {
            throw error;
        } finally {
            commit('SET_UI_FLAG', { isUpdating: false });
        }
    },

    async delete({ commit, state: $state }, { assistantId, promptId }) {
        commit('SET_UI_FLAG', { isDeleting: true });
        try {
            await CopilotPromptsAPI.destroy(assistantId, promptId);
            const record = $state.records.find(r => r.id === promptId);
            if (record) {
                commit('UPDATE_RECORD', {
                    ...record,
                    deleted_at: Math.floor(Date.now() / 1000),
                });
            }
        } catch (error) {
            throw error;
        } finally {
            commit('SET_UI_FLAG', { isDeleting: false });
        }
    },

    async restore({ commit }, { assistantId, promptId }) {
        try {
            const { data } = await CopilotPromptsAPI.restore(
                assistantId,
                promptId
            );
            commit('UPDATE_RECORD', data);
            return data;
        } catch (error) {
            throw error;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
